var _circle, _rect, _path, _rect2, _path2, _rect3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourseWalk3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 18.2144,
    r: 17.5,
    fill: "#474C5A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9.71436,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#A1A3B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5894L8.87554 12.4923C8.9934 12.6138 9.18842 12.6138 9.30628 12.4923L12 9.71436",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23.7144,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#A1A3B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 25.5894L8.87554 26.4923C8.9934 26.6138 9.18842 26.6138 9.30628 26.4923L12 23.7144",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16.7144,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#A1A3B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09088 19.7144L11 16.7144M8 16.7144L11 19.7144",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseWalk3);
export default __webpack_public_path__ + "static/media/course_walk_3.30bee6a3.svg";
export { ForwardRef as ReactComponent };